// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__9TJd1","jw-logo":"Footer_jw-logo__1zz1p"};